import React from "react";
import { Link } from "react-router-dom";
import { colors as DS, TechLabel } from "../../../design-system";

const ACCENT = DS.product.jobs;

export default function RegisterNavbar() {
  return (
    <nav
      className="sticky top-0 z-50 border-b px-4 sm:px-12 py-3 flex justify-between items-center"
      style={{
        background: "rgba(247,247,245,0.92)",
        backdropFilter: "saturate(160%) blur(14px)",
        WebkitBackdropFilter: "saturate(160%) blur(14px)",
        borderColor: DS.hairline,
        fontFamily: "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif",
      }}
    >
      <Link to="/jobs" className="flex items-center gap-3 group">
        <img
          src="/logo 2.jpg"
          alt="WebIdeal Logo"
          className="w-11 h-11 object-contain bg-white p-1 transform group-hover:scale-105 transition-transform duration-300"
          style={{ border: `1px solid ${DS.hairline}` }}
        />
        <div>
          <span className="text-lg font-extrabold tracking-tight" style={{ color: DS.forest }}>
            WebIdeal
          </span>
          <TechLabel style={{ color: ACCENT }}>module · jobs · register</TechLabel>
        </div>
      </Link>

      <div className="text-xs font-bold uppercase flex items-center gap-2" style={{ letterSpacing: "0.16em", color: DS.grid }}>
        <span className="hidden sm:inline">Already registered?</span>
        <Link
          to="/jobs/auth"
          className="inline-flex items-center px-3.5 py-2 border transition-colors duration-150 hover:bg-[#1A3C2B]/[0.04]"
          style={{ borderColor: DS.forest, color: DS.forest }}
        >
          Login
        </Link>
      </div>
    </nav>
  );
}
